import { PREMIUM_TYPE } from 'constants/common';

export const premiumTypesOptions = [
  { label: 'Subscription', value: PREMIUM_TYPE.SUBSCRIPTION },
  { label: 'Single payment', value: PREMIUM_TYPE.SINGLE_PAYMENT },
];
